import { render } from "./CleaningItems.vue?vue&type=template&id=674467e4"
import script from "./CleaningItems.vue?vue&type=script&lang=js"
export * from "./CleaningItems.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__